import { createAsyncThunk } from '@reduxjs/toolkit';

import type { TRootState } from 'store';
import { removeUserSession } from 'services/user/user.helper';
import { teamHeroApi } from 'services/teamHeroApi.service';
import { setNotification } from 'redux/notification/notification.slice';
import { clearUser } from './user.slice';

export const logout = createAsyncThunk(
  'user/logout',
  async (_, { dispatch }) => {
    removeUserSession();
    dispatch(clearUser());
    // resets all teamHeroApi Caches and invalidates all tags
    dispatch(teamHeroApi.util.resetApiState());
  }
);

export const logoutByForce = createAsyncThunk(
  'user/logoutByForce',
  async (_, { dispatch, getState }) => {
    removeUserSession();
    // already logged out. Resetting the api state again would make mounted
    // queries refetch, and each of them would end up here once more
    if (!(getState() as TRootState).user.isLoggedIn) {
      return;
    }
    dispatch(clearUser());
    dispatch(
      setNotification({
        type: 'error',
        message: `You have been logged out`,
      })
    );
    // reset all teamHeroApi Caches and invalidates all tags
    dispatch(teamHeroApi.util.resetApiState());
  }
);
